import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { DatabaseSvg } from './DatabaseSvg2'

export const EaDatabaseIcon = (props: PropsWithoutRef<IconBaseProps>) => (
  <Icon component={DatabaseSvg} {...props} />
)
